// extracted by mini-css-extract-plugin
export default {"notFound":"_404--notFound--3CXYj","paperPlaneImg":"_404--paperPlaneImg--19EH5","title":"_404--title--16dpB","description":"_404--description--3j3pu","button":"_404--button--31TjM"};